import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion, AnimatePresence } from "framer-motion";
import {
  FaShieldAlt,
  FaTruck,
  FaUndo,
  FaCreditCard,
  FaCheckCircle,
  FaPlus,
  FaMinus
} from "react-icons/fa";
import "./faqs.css";

const faqData = [
  {
    icon: <FaShieldAlt />,
    question: "Is there an official warranty?",
    answer:
      "All products come with official brand warranty and certified authenticity guarantee."
  },
  {
    icon: <FaTruck />,
    question: "How fast is delivery?",
    answer:
      "We provide express and standard delivery with real-time tracking support."
  },
  {
    icon: <FaUndo />,
    question: "Easy returns available?",
    answer:
      "Yes, 7-day hassle-free return policy on eligible electronics."
  },
  {
    icon: <FaCreditCard />,
    question: "EMI & payment options?",
    answer:
      "We support No-Cost EMI, UPI, Cards, and digital wallets."
  },
  {
    icon: <FaCheckCircle />,
    question: "Are products 100% genuine?",
    answer:
      "We sell only brand-authorized and verified electronic products."
  }
];

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const handleClick = (index) => {
    setActiveIndex(prev => (prev === index ? null : index));
  };

  return (
    <section className="faq-section">
      <Container>

        {/* Title + Subtitle */}
        <Row className="justify-content-center text-center mb-5">
          <Col lg={8}>
            <motion.h2
              className="faq-title"
              initial={{ opacity: 0, y: -30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              Frequently Asked Questions
            </motion.h2>

            <motion.p
              className="faq-subtitle"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.3 }}
            >
              Everything you need to know about our products, delivery and policies.
            </motion.p>
          </Col>
        </Row>

        {/* FAQ Items */}
        <Row className="justify-content-center">
          <Col lg={8}>
            {faqData.map((item, index) => {
              const isActive = activeIndex === index;

              return (
                <motion.div
                  key={index}
                  layout
                  className={`faq-card ${isActive ? "active" : ""}`}
                  onClick={() => handleClick(index)}
                  whileHover={{ scale: 1.02 }}
                  transition={{ duration: 0.3 }}
                >
                  <div className="faq-header">
                    <div className="faq-icon">{item.icon}</div>
                    <h6>{item.question}</h6>
                    <div className="faq-toggle">
                      {isActive ? <FaMinus /> : <FaPlus />}
                    </div>
                  </div>

                  <AnimatePresence>
                    {isActive && (
                      <motion.div
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.35 }}
                        className="faq-body"
                      >
                        <p>{item.answer}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </motion.div>
              );
            })}
          </Col>
        </Row>

      </Container>
    </section>
  );
};

export default Faqs;
